var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 页面上有模块加载器时，引入 CDN js 时，js 如果是 UMD / AMD / CJS 格式，则会注册到对应模块加载器上
 * 这个函数再将 CDN JS 实际的导出从模块加载器上引入回来
 *
 * @param moduleName 模块名，一般为打包工具 libraryName 配置，或者调用模块加载器注册时的名称
 * @param globalName UMD / IIFE 挂载到 window 对象上的名称，不传则使用 moduleName
 */
export function requireModule(moduleName, globalName) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var context;
        return __generator(this, function (_b) {
            context = self;
            try {
                // Cjs 模块加载器
                if (typeof ((_a = context.module) === null || _a === void 0 ? void 0 : _a.export) === 'object') {
                    return [2 /*return*/, context.module.export[moduleName]];
                }
                // AMD 模块加载器
                if (typeof context.define === 'function' && context.define.amd && typeof context.require === 'function') {
                    return [2 /*return*/, new Promise(function (res) {
                            context.require([moduleName], function (moduleExport) {
                                res(moduleExport);
                            });
                        })];
                }
            }
            catch (_c) { }
            // IIFE Mode / 兜底
            return [2 /*return*/, context[globalName || moduleName]];
        });
    });
}
/**
 * 将某个属性挂载到 window 下，在挂载前检查 window 下是否有同名属性。
 * 当存在同名属性，或是挂载后属性被覆盖为其他对象时，触发回调
 * 比如下列 case
 * ```ts
 * const a = {};
 * mountGlobal({ globalName: 'A', target: a });
 * // 拦截，引用不一样
 * window.A = {};
 * // 放行，引用是一致的
 * window.A = a;
 * // 放行，有可能需要移除包的副作用
 * window.A = null;
 * window.A = undefined;
 * delete window.A;
 * ```
 * 具体所有 case 覆盖参考: https://git.woa.com/wizzeng/multi-player-detect
 */
export function mountGlobal(options) {
    var globalName = options.globalName, target = options.target, onDuplicate = options.onDuplicate;
    // 如果模块已经被引入了，则不挂载，触发回调，不过如果引用一致则放行
    if (window[globalName] && window[globalName] !== target) {
        onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate(window[globalName]);
    }
    else {
        // 将 target 设置为 window 下的 getter / setter 模式，当 set 时，检查覆盖的行为是否符合预期
        // 这里一定需要使用 defineProperty 将属性设置为 getter / setter，防止先引入新版本，在引入老版本时，挂在 global 的属性被老版本上的逻辑覆盖
        Object.defineProperty(window, globalName, {
            configurable: true,
            enumerable: true,
            get: function () {
                return target;
            },
            set: function (val) {
                if (val && val !== target) {
                    // 如果为非空值，很可能为非预期的覆盖行为，触发回调
                    onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate(window[globalName]);
                }
                else {
                    // 赋空值视为合法
                    delete window[globalName];
                    window[globalName] = val;
                }
            },
        });
    }
}
